export default __webpack_public_path__ + "static/media/icon3dwork.64488635.png";